import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';

import { makeImagePreviewable } from '../utils';

const Image = ({ content, style, aspectRatio }) => {
  const image = makeImagePreviewable(content);

  if (!image.localFile) {
    return <p>missing</p>;
  }

  return image.localFile.childImageSharp?.fluid ? (
    <Img
      fluid={{
        ...image.localFile.childImageSharp.fluid,
        ...(aspectRatio ? { aspectRatio } : {}),
      }}
      alt={image.alt}
      imgStyle={style}
    />
  ) : (
    <img src={image.localFile.url} alt={image.alt} style={style} />
  );
};

Image.defaultProps = {
  style: {},
  aspectRatio: null,
};

Image.propTypes = {
  content: PropTypes.shape({
    localFile: PropTypes.shape({
      extension: PropTypes.string,
      url: PropTypes.string,
      childImageSharp: PropTypes.shape({ fluid: PropTypes.shape({}) }),
    }),
    alt: PropTypes.string,
  }).isRequired,
  style: PropTypes.shape({}),
  aspectRatio: PropTypes.number,
};

export default Image;
